(function() {
  const overrideSheet = new CSSStyleSheet();
  overrideSheet.replaceSync(`
    .dialog .account {
        height: unset !important;
    }
  `);

  function applyOverride() {
    const account = document.querySelector('shopify-account');
    if (!account?.shadowRoot) return;

    account.shadowRoot.adoptedStyleSheets = [
      ...account.shadowRoot.adoptedStyleSheets,
      overrideSheet
    ];
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', applyOverride);
  } else {
    applyOverride();
  }

  // Re-apply if the component gets re-rendered
  document.addEventListener('shopify:section:load', applyOverride);
})();